import { requiredStrategy } from '../core';
import { cdccNumberFormatStrategy } from './cdcc-number-format-strategy';
import { cdccNumberLengthStrategy } from './cdcc-number-length-strategy';

// cdcc = Citizen Digital Certificate Carrier
// 自然人憑證載具號碼
export const cdccNumberStrategy = (value: string) => {
  return (
    requiredStrategy(value) &&
    cdccNumberLengthStrategy(value) &&
    cdccNumberFormatStrategy(value)
  );
};
